import React from 'react';
import store from 'javascripts/store';
import {observer} from 'mobx-react';

@observer
class SpringMemberExistsMessage extends React.Component {
  logout = () => {
    $.ajax({
      method: 'DELETE',
      url: '/account/logout',
    }).done(() => {
      window.location.reload();
    });
  }

  render() {
    return (
      <>
        { store.donateForm.showUsToUkConversionMessage ?
          <>
            <div className='p-2 bg-grey-5'>
              <div className='flex items-end mb-1'>
                <h3 className='h80 mb-0 leading-normal'>
                  A Spring membership already exists for {store.donateForm.email}
                  { store.donateForm.isUserLoggedIn &&
                    <span className='font-light'> (<a className='text-cw-black underline' onClick={this.logout}>not you?</a>)</span>
                  }
                </h3>
              </div>
              <p className='text-small mb-1 leading-normal'>
                Your current account is giving in USD. That means you&apos;re missing the chance to amplify your impact through Gift&nbsp;Aid.
              </p>
              <p className='text-small mb-1 leading-normal'>
                To switch your subscription to GBP, continue below. We&apos;ll automatically cancel your old subscription once you complete your new&nbsp;one.
              </p>
              <p className='text-small leading-normal'>
                Don&apos;t want to switch? Head over to <a className='underline' href={`//${store.donateForm.host}/account/settings`}>your Settings tab</a> from your account dashboard to manage your giving&nbsp;in&nbsp;USD.
              </p>
            </div>
            <a
              className='button mt-2 w-full'
              onClick={() => store.donateForm.membershipAlreadyExistsMessageDisabled = true}
            >
              Continue
            </a>
          </>
        :
          <>
            <div className='p-2 bg-grey-5'>
              <div className='flex items-end mb-1'>
                <h3 className='h80 mb-0 leading-normal'>
                  A Spring membership already exists for {store.donateForm.email}
                  { store.donateForm.isUserLoggedIn &&
                    <span className='font-light'> (<a className='text-cw-black underline' onClick={this.logout}>not you?</a>)</span>
                  }
                </h3>
              </div>
              <p className='text-small m-0 leading-normal'>
                We&apos;re so glad you&apos;re already part of the Spring community! Thank you. At this time, we don&apos;t allow multiple monthly gifts from the same charity: water account. To manage your account, head over to <a className='underline' href={`//${store.donateForm.host}/account/settings`}>your Settings tab</a> from your account dashboard.
              </p>
            </div>
            <a
              className='button mt-2 w-full'
              href='/donate'
            >
              Give once instead
            </a>
          </>
        }
      </>
    );
  }
}

export default SpringMemberExistsMessage;
